import { CollectionViewer,DataSource} from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ReportsService } from '../../services/reports.service';
export class DeletedUsersDataSource implements DataSource<any>{
  private usersSubject=new BehaviorSubject<any>([])
  private usersLoadingSubject=new BehaviorSubject<boolean>(false)
  isLoading=this.usersLoadingSubject.asObservable()
  totalUsers=0
  constructor(private reportsService:ReportsService){}
  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.usersSubject.asObservable()
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.usersSubject.complete()
    this.usersLoadingSubject.complete()
  }
  listallDeletedUsers_within_App(orgId,pageNumber=1,pageSize=10,sortField,sortType,searchText,searchField,startDate=null,endDate=null) {
    this.usersLoadingSubject.next(true)
    this.reportsService.listallDeletedUsers_within_App(orgId,pageNumber,pageSize,sortField,sortType,searchText,searchField,startDate,endDate)
    .pipe(
      catchError(()=>of([])),
      finalize(()=>this.usersLoadingSubject.next(false))
    )
    .subscribe((res:any) => {
      this.totalUsers=res.totalUsers
      this.usersSubject.next(res.data)
    })
  }
}
